angular.module('app')
.filter('languageFilter', function($rootScope) {
  return function(input) {
    const isStaff = _.get($rootScope,'user.isStaff', false)
    return isStaff ? input : _.reject(input, { staff: true })
  };
})
